import { tv } from "../../../variants/tv.js";
const calendarVariants = tv({
    slots: {
        root: 'bg-primary-1 relative box-border',
        monthCaption: 'flex w-full items-center justify-center py-2',
        buttonPreviousContainer: 'absolute left-0 top-0 flex cursor-pointer',
        buttonNextContainer: 'absolute right-0 top-0 flex cursor-pointer',
        buttonPrevious: 'h-8 w-8',
        buttonNext: 'h-8 w-8',
        captionLabel: 'text-heading5 text-primary-13 capitalize',
        nav: '',
        months: 'relative flex [&>div:not(:first-of-type)]:ml-4',
        month: 'flex flex-col',
        weekdays: 'py-2',
        weekRow: [
            ''
        ],
        weekHeader: [
            ''
        ],
        daysGrid: [
            ''
        ],
        weeks: '',
        week: '',
        weekday: 'text-body3 text-primary-10 h-11 w-11',
        weekNumber: '',
        day: [
            'focus-visible:outline-none',
            'text-body1 aspect-square h-11 w-11'
        ],
        dayButton: [
            'h-full max-h-11 w-full',
            'text-body1 text-neutral-11 box-border flex cursor-pointer items-center justify-center rounded-lg',
            'hover:text-neutral-12 hover:bg-primary-4',
            'focus-visible:ring-primary-8 focus-visible:rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset',
            'disabled:text-neutral-6 disabled:cursor-not-allowed disabled:hover:bg-transparent'
        ],
        today: '',
        outsideDay: 'text-neutral-8',
        selectedDays: [
            'selected-day [&>button]:bg-primary-8 [&>button]:text-primary-1 [&>button]:hover:bg-primary-8 [&>button]:hover:text-primary-1',
            '[&>button]:focus-visible:ring-primary-11 [&>button]:focus-visible:ring-3 [&>button]:focus-visible:rounded-lg [&>button]:focus-visible:outline-none [&>button]:focus-visible:ring-inset'
        ],
        rangeStart: [
            'range-start',
            '[&>button]:rounded-br-none [&>button]:rounded-tr-none'
        ],
        rangeMiddle: [
            'range-middle',
            '[&>button]:bg-primary-11 [&>button]:text-primary-1 [&>button]:hover:bg-primary-11 [&>button]:hover:text-primary-1',
            '[&>button]:rounded-none'
        ],
        rangeEnd: [
            'range-end',
            '[&>button]:rounded-bl-none [&>button]:rounded-tl-none'
        ],
        chevron: 'fill-primary-8 inline-block h-5 w-5',
        dropdowns: '',
        dropdown: '',
        dropdownRoot: '',
        monthGrid: '',
        disabled: 'text-neutral-6 cursor-not-allowed',
        hidden: 'invisible',
        focusable: ''
    },
    variants: {
        heatMapVariant: {
            day: {},
            dayIcon: {},
            dayHeatMap: {
                day: 'h-12',
                dayButton: 'border-primary-1 border-1 flex max-h-12 flex-col justify-start py-[2px]'
            },
            dayBelowAvg: {
                day: 'h-12',
                dayButton: 'flex max-h-12 flex-col justify-start py-1'
            }
        },
        colorVariant: {
            DEFAULT: {
                dayButton: ''
            },
            EXCELLENT: {
                dayButton: 'bg-success-3'
            },
            GOOD: {
                dayButton: 'bg-caution-3'
            },
            HIGH: {
                dayButton: 'bg-error-3'
            }
        },
        isMobile: {
            true: {
                root: 'w-full',
                months: 'flex flex-col gap-1 [&>div:not(:first-of-type)]:ml-0',
                monthCaption: 'justify-start'
            }
        }
    }
});
export { calendarVariants };
